export default "__VITE_ASSET__C5VEZ2Mi__"